/* eslint-disable multiline-ternary */
/* eslint-disable max-len */
import React, { useEffect } from 'react';
import PropTypes from 'prop-types';

import Typography from '../../base/Typography';

import {
  DescriptionList,
  DescriptionListTypography,
  DescriptionListItems,
  DescriptionDetails,
  DescriptionTerm,
} from './styles';

export const DescriptionListComponent = ({
  descriptionListData,
}) => {
  useEffect(() => {
    // validate all descriptionListData passed in are correct
    if (descriptionListData.length === 0) {
      console.error('Missing description list data. At least one entry is required.');
    }
  }, []);
  return (
    <DescriptionList>
      { descriptionListData.map(item => (
        <DescriptionListItems key={item}>
          <DescriptionListTypography
                align='left'
                component='p'
                weight={400}>
            <DescriptionTerm>
              {item.descriptionTerm}&nbsp;
            </DescriptionTerm>
            <Typography
                align='left'
                component='span'
                weight={200}>
              <DescriptionDetails>
                {item.descriptionDetails}
                {item.sup && (<sup>{item.sup}</sup>)}
              </DescriptionDetails>
            </Typography>
          </DescriptionListTypography>
        </DescriptionListItems>
      ))}
    </DescriptionList>
  );
};

DescriptionListComponent.propTypes = {
  /** Array of accoladed to display in the section */
  descriptionListData: PropTypes.arrayOf(PropTypes.shape({
    /** The 'id' of the accolade wanting to display */
    descriptionTerm: PropTypes.string.isRequired,
    /** The sup number corresponding with the footer reference, Required for descriptionListData needing source to cite */
    descriptionDetails: PropTypes.any.isRequired,
  })).isRequired,
};

export default DescriptionListComponent;
